export const LANDING = {
  // Header
  headerLogo: "header-logo",
  headerCtaHero: "header-cta-hero",
  // Hero
  heroBadge: "hero-badge",
  heroHeadline: "hero-headline",
  heroVideoPlaceholder: "hero-video-placeholder",
  heroCta: "hero-cta",
  // Intermediate CTA
  intermediateCta: "intermediate-cta",
  // Method phases
  methodPhaseCard: "method-phase-card",
  // For whom
  forWhomYes: "for-whom-yes",
  forWhomNo: "for-whom-no",
  // Deliverables
  deliverablesModule: "deliverables-module",
  // Bonuses
  bonusItem: "bonus-item",
  // Testimonials
  testimonialItem: "testimonial-item",
  // FAQ
  faqAccordion: "faq-accordion",
  faqItem: "faq-item",
  // Final
  finalCta: "final-cta",
  finalCtaBottom: "final-cta-bottom",
  // Whatsapp / Footer
  whatsappFloating: "whatsapp-floating",
  footerLogo: "footer-logo",
};
